import { Text } from '@wistia/vhs';
import styled, { css } from 'styled-components';

export const SpeakerBioItem = styled.div<{
  isEventRoom: boolean;
  hasBio: boolean;
  hasOverflowText: boolean;
  isHovering: boolean;
}>`
  box-shadow: ${({ theme, isHovering, hasOverflowText }) =>
    hasOverflowText && isHovering ? theme.shadow.elevation1 : 'none'};
  height: auto;
  width: 100%;
`;

export const SpeakerBioItemContainer = styled.div<{
  isEventRoom: boolean;
  hasBio: boolean;
  showBio: boolean;
}>`
  align-items: center;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  justify-content: space-between;
  max-height: ${({ showBio }) => (showBio ? '1500px' : '400px')};
  min-height: ${({ hasBio }) => (hasBio ? '250px' : 'auto')};
  width: 100%;
  max-width: 100%;
  height: 100%;
  padding: 1.5rem;
  position: relative;

  ${({ showBio }) => !showBio && { maxHeight: '400px' }}

  ${({ showBio }) =>
    !showBio &&
    css`
      .bio {
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 4;
        display: -webkit-box;
        overflow: hidden;
      }
    `}
`;

export const BioWrapper = styled.div<{ hasOverflowText: boolean }>`
  overflow-y: ${({ hasOverflowText }) => (hasOverflowText ? 'hidden' : 'visible')};
  width: 100%;
  word-wrap: break-word;
  overflow-wrap: break-word;

  p {
    margin: 0;
    max-width: 100%;
  }
`;

export const Bio = styled(Text)<{ isEventRoom: boolean }>``;

export const SpeakerTileText = styled(Text)<{ isEventRoom: boolean }>`
  max-width: 100%;
  word-wrap: break-word;
  overflow: hidden;
  text-overflow: ellipsis;

  &.title {
    font-size: 14px;
  }
`;

export const FullBioToggle = styled(Text)<{ isEventRoom: boolean }>`
  cursor: pointer;
  text-decoration: underline;
  position: 'relative';
  text-align: 'right';
`;
